import { atom } from "jotai";
import capitalizeFirstLetter from "../../../canvas/src/utils/capitalizeFirstLetter";
import { formsTerminologyAtom } from "../diagramming";
import { AssetType } from "../types";

/**
 * Atom that returns a function to get the capitalized user-facing display name for an asset type.
 * Handles the special case for "interface" which can be "Interface" or "Form" depending on rebrand toggle.
 * All other types are simply capitalized.
 */
export const capitalizedAssetTypeDisplayAtom = atom((get) => {
  const formsTerms = get(formsTerminologyAtom);

  return (assetType: AssetType): string => {
    if (!assetType) {
      return "";
    }

    if (assetType === "interface") {
      return formsTerms.singular;
    }

    // For all other types (zap, table, chatbot, agent) - capitalize first letter
    return capitalizeFirstLetter(assetType);
  };
});
